import { EnumOption } from "./enum-option";

export const FNDocumentType = {
    I94: 0,
    Visa: 1,
    EAD: 2,
    APD: 3,
    Passport: 4,
    GreenCard: 5,
    HLStatus: 6,
    Biometric: 7,
    Fingerprint: 8,
    I797: 9,
    ReEntryPermit: 10,
    DS2019: 11,
    EADAP: 12,
    NaturalizationEligibilityDate : 13,
    I751 : 14,
};

export const FNDocumentTypeList: EnumOption[] = [
    { value: FNDocumentType.I94, label: 'I-94' },
    { value: FNDocumentType.Visa, label: 'Visa' },
    { value: FNDocumentType.EAD, label: 'EAD' },
    { value: FNDocumentType.APD, label: 'Advance Parole Date' },
    { value: FNDocumentType.Passport, label: 'Passport' },
    { value: FNDocumentType.GreenCard, label: 'Green Card' },
    { value: FNDocumentType.HLStatus, label: 'Maximum Validity Period of H or L Status' },
    { value: FNDocumentType.Biometric, label: 'Biometric Scan Date' },
    { value: FNDocumentType.Fingerprint, label: 'FBI Cleared Date (Fingerprint)' },
    { value: FNDocumentType.I797, label: 'I-797' },
    { value: FNDocumentType.ReEntryPermit, label: 'Re-entry Permit Info' },
    { value: FNDocumentType.DS2019, label: 'DS-2019' },
    { value: FNDocumentType.EADAP, label: 'EAD/APD' },
    { value: FNDocumentType.NaturalizationEligibilityDate, label: 'Eligibility Date For Naturalization' },
    { value: FNDocumentType.I751, label: 'I-751' },
];